// extracted by mini-css-extract-plugin
export default {"section":"Cs-z","sectionTitle":"Ds-z","fieldWrapper":"Es-z","formField":"Fs-z","disabled":"Gs-z","formLabel":"Hs-z"};